module.exports = __webpack_public_path__ + "img/pet-care.e168d5b1.png";